import { useState, useEffect } from 'react';
import type { CookiePreferences } from '@/components/CookieSettings';

export const useCookieConsent = () => {
  const [hasConsent, setHasConsent] = useState<boolean | null>(null);
  const [preferences, setPreferences] = useState<CookiePreferences>({
    necessary: true,
    analytics: false,
    marketing: false,
    preferences: false,
  });

  useEffect(() => {
    // Check if user has already given consent
    const storedConsent = localStorage.getItem('cookie-consent');
    const storedPreferences = localStorage.getItem('cookie-preferences');
    
    if (storedConsent === 'true' && storedPreferences) {
      setHasConsent(true);
      setPreferences(JSON.parse(storedPreferences));
    } else {
      setHasConsent(false);
    }
  }, []);

  const giveConsent = (cookiePreferences: CookiePreferences) => {
    localStorage.setItem('cookie-consent', 'true');
    localStorage.setItem('cookie-preferences', JSON.stringify(cookiePreferences));
    setHasConsent(true);
    setPreferences(cookiePreferences);

    // Initialize analytics and marketing tools based on preferences
    if (cookiePreferences.analytics) {
      // Initialize analytics (Google Analytics, etc.)
      console.log('Analytics cookies enabled');
    }
    
    if (cookiePreferences.marketing) {
      // Initialize marketing tools (Facebook Pixel, etc.)
      console.log('Marketing cookies enabled');
    }

    if (cookiePreferences.preferences) {
      // Initialize preference cookies
      console.log('Preference cookies enabled');
    }
  };

  const revokeConsent = () => {
    localStorage.removeItem('cookie-consent');
    localStorage.removeItem('cookie-preferences');
    setHasConsent(false);
    setPreferences({
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false,
    });
  };

  const updatePreferences = (newPreferences: CookiePreferences) => {
    localStorage.setItem('cookie-preferences', JSON.stringify(newPreferences));
    setPreferences(newPreferences);
  };

  return {
    hasConsent,
    preferences,
    giveConsent,
    revokeConsent,
    updatePreferences,
  };
};